<script setup lang="ts">
import { computed } from 'vue'
import { AccreditationStatuses, type AccreditationStatus } from '../types'

const props = defineProps<{
  status: AccreditationStatus
}>()

const state = computed(() => {
  switch (props.status) {
    case AccreditationStatuses.Accredited:
      return {
        color: 'v-blue',
        label: 'Accredited',
        description: 'You meet the criteria to be an accredited investor.',
      }
    case AccreditationStatuses.QualifiedPurchaser:
      return {
        color: 'v-blue',
        label: 'Qualified Purchaser',
        description: 'You meet the criteria to be a qualified purchaser.',
      }
    case AccreditationStatuses.NotAccredited:
      return {
        color: 'gray',
        label: 'Not Accredited',
        description: 'You do not meet the criteria to be an accredited investor.',
      }
  }
})
const bgGradient = computed(() => {
  return props.status === AccreditationStatuses.NotAccredited
    ? 'bg-gradient-to-r from-red-700 to-red-800'
    : 'bg-gradient-to-r from-[#3982AF] to-[#408F92]'
})
</script>

<template>
  <div class="rounded-lg p-3 text-sm text-white" :class="bgGradient" v-if="status">
    <div class="mb-1 text-lg font-bold">{{ state.label }}</div>
    <div class="">{{ state.description }}</div>
  </div>
</template>
